// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__Oi9PC","question":"Question_question__3wlOL","description":"Question_description__1MWs6"};